module.exports = __webpack_public_path__ + "img/gzh.17decaf2.png";